import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "../lib/api";
const POLL_MS = 30000;  // increased from 20s → 30s

/**
 * Polls GET /messages/admin-replies/unread-count every 30s.
 * Only active when `enabled` is true (any logged-in non-admin user).
 *
 * @param {boolean} enabled
 * @returns {{ count: number, refresh: Function }}
 */
export function useAdminUnread(enabled = true) {
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async () => {
    try {
      const res = await axios.get(
        `${API}/messages/admin-replies/unread-count`,
        { withCredentials: true }
      );
      setCount(res.data.unread_from_admin || 0);
    } catch {
      /* silent */
    }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    fetchCount();
    const id = setInterval(fetchCount, POLL_MS);
    return () => clearInterval(id);
  }, [enabled, fetchCount]);

  return { count, refresh: fetchCount };
}
